/** 한국시간 이 시점 이후 지류 상품권 탭 미노출 (모바일만) */
const PAPER_TAB_END_KST = "2026-04-01T00:00:00+09:00";

export function getGiftCardTabTitles() {
  // 테스트: 3/31 15:30 KST — 아직 지류 탭 있어야 함 (배포 전 확인용, 사용 시만 주석 해제)
  // const now = new Date("2026-03-31T15:30:00+09:00");
  const now = new Date();

  return now >= new Date(PAPER_TAB_END_KST)
    ? ["모바일 상품권"]
    : ["모바일 상품권", "지류 상품권"];
}
